import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { INFO_CONTENT, COMPANY, MEDIA } from "@/lib/company";
import { ArrowLeft, Phone, Mail } from "lucide-react";

export default function InfoPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const content = INFO_CONTENT[slug] || {
    title: "Page",
    intro: "This information is coming soon.",
    body: ["Our team is preparing this content. In the meantime, reach us using the details below."],
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100">
      <Navbar />
      <section className="relative overflow-hidden">
        <img src={MEDIA.terminalAerial} alt="" className="absolute inset-0 h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/92 via-slate-950/90 to-[#0B0F17]" />
        <div className="relative mx-auto max-w-4xl px-4 py-20 sm:px-6">
          <button onClick={() => navigate(-1)} className="mb-5 inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-orange-300">
            <ArrowLeft className="h-4 w-4" /> Back
          </button>
          <p className="mb-2 text-xs font-mono uppercase tracking-[0.25em] text-orange-400">{COMPANY.name}</p>
          <h1 className="text-3xl font-black tracking-tight sm:text-5xl" data-testid="info-page-title">{content.title}</h1>
          <p className="mt-4 max-w-2xl text-lg text-slate-300">{content.intro}</p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <div className="space-y-5 text-base leading-relaxed text-slate-300">
          {content.body.map((p, i) => <p key={`${slug}-para-${i}`}>{p}</p>)}
        </div>

        <div className="mt-10 rounded-2xl border border-white/10 bg-slate-900/60 p-6">
          <p className="text-xs font-mono uppercase tracking-wider text-slate-500">Get in touch</p>
          <div className="mt-3 flex flex-col gap-3 sm:flex-row">
            <a href={`tel:${COMPANY.phone}`} className="flex items-center gap-2 text-slate-200 hover:text-orange-300">
              <Phone className="h-4 w-4 text-orange-400" /> {COMPANY.phone}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 break-all text-slate-200 hover:text-orange-300">
              <Mail className="h-4 w-4 text-orange-400" /> {COMPANY.email}
            </a>
          </div>
          <Button asChild className="mt-5 bg-orange-600 text-white hover:bg-orange-700">
            <Link to="/contact">Contact Us</Link>
          </Button>
        </div>
      </section>
      <Footer />
    </div>
  );
}
